import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useLocalParticipant, useDevices, useDaily } from '@daily-co/daily-react';
import { pageAtom, topMessageAtom } from '../../State';
import { useSetRecoilState } from 'recoil';
import { useNavigate, useLocation } from 'react-router-dom';
import { ReactComponent as CloseSVG } from '../Images/buttons/closeBlackButton.svg';
import DataModel from '../Util/DataModel';
import { ReactComponent as FacelessBoySVG } from '../Images/buttons/electronTopBottom.svg';
import { getAuth, sendSignInLinkToEmail, signInWithCustomToken } from 'firebase/auth';
import { useTranslation } from 'react-i18next';
import KUTE from 'kute.js';

export default function BrowserJoin({ setShowJoin }) {
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const [codeState, setCodeState] = useState('');
  const inputRef = useRef(null);
  const { t } = useTranslation();
  const navigate = useNavigate(); //リダイレクト用

  const handleChange = (event) => {
    setCodeState(event.target.value);
  };

  const tapClose = (event) => {
    setCodeState('');
    setShowJoin(false);
  };

  const tapSend = async () => {
    if (codeState != '') {
      let str = codeState.replace(/https?:\/\/[^\/]+/i, '');
      // var result = str.slice(1);
      navigate(str);

      tapClose();
    }
  };

  useEffect(() => {
    let kute = KUTE.to(
      '#electronJoinWrap',
      { top: '15%', opacity: 1 },
      {
        duration: 200,
        easing: 'easingCubicOut',
        onComplete: () => {},
      },
    );
    kute.start();
  }, []);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  const handleKeyDown = (e) => {
    if (e.key !== 'Enter') return;
    tapSend();
  };

  //レンダー
  return (
    <>
      <div className="addAreaBack"></div>
      <div id="electronJoinWrap">
        <div id="electronEmailInside">
          <>
            <div className="electronEmailClose" onClick={tapClose}>
              <CloseSVG />
            </div>
            {/*コード入力 */}
            <h1>{t('mypage.Join Meeting')}</h1>
            <div id="codeDetail">{t('mypage.Paste meeting url')} </div>
            <input
              id="electronEmailInput"
              name="email"
              type="text"
              placeholder="https://faceless.ooo/xxxx"
              onChange={(e) => handleChange(e)}
              value={codeState}
              ref={inputRef}
              onKeyDown={handleKeyDown}
            />
            <button disabled={codeState != '' ? false : true} onClick={tapSend}>
              {t('haircheck.Join Now')}
            </button>
          </>
        </div>
      </div>
    </>
  );
}
